import styled from "styled-components/macro";

export const TableContainer = styled.div`
    position: relative;
    display: flex;
    padding: 16px;
    margin: 0 16px;
    overflow: hidden;
    flex-direction: row;
`;